
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Project"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"path"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"project_with_path"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"path"},"value":{"kind":"Variable","name":{"kind":"Name","value":"path"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectThresholds"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"simulate_carbon_footprint"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPlant"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"simulate_food_safety"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectFoodType"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectPackagingSystem"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProjectStorageCondition"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EditLockOwner"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Boards"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SimulationResults"},"directives":[]}]}}]}}],"loc":{"start":0,"end":717}};
    doc.loc.source = {"body":"#import \"./EditLockOwnerFragment.graphql\"\n#import \"./BoardsFragment.graphql\"\n#import \"./SimulationResultsFragment.graphql\"\n#import \"./ProjectThresholdsFragment.graphql\"\n#import \"./ProjectPlantFragment.graphql\"\n#import \"./ProjectFoodTypeFragment.graphql\"\n#import \"./ProjectPackagingSystemFragment.graphql\"\n#import \"./ProjectStorageConditionFragment.graphql\"\n\nquery Project($path: String!) {\n  project_with_path(path: $path) {\n    id\n    name\n    description\n    owner\n    ...ProjectThresholds\n    simulate_carbon_footprint\n    ...ProjectPlant\n    simulate_food_safety\n    ...ProjectFoodType\n    ...ProjectPackagingSystem\n    ...ProjectStorageCondition\n    ...EditLockOwner\n    ...Boards\n    ...SimulationResults\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./EditLockOwnerFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./BoardsFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./SimulationResultsFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ProjectThresholdsFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ProjectPlantFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ProjectFoodTypeFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ProjectPackagingSystemFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./ProjectStorageConditionFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      return doc.definitions.find(function(op) {
        return op.name ? op.name.value == name : false;
      });
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = Object.assign({}, doc);

      var op = findOperation(doc, operationName);
      newDoc.definitions = [op];

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["Project"] = oneQuery(doc, "Project");
        



//////////////////
// WEBPACK FOOTER
// ./src/graphql/Project.graphql
// module id = 1FK0
// module chunks = 1